export const predictions = [
  { id: 1, text: 'Доля готує для тебе зустріч, яка принесе багато усмішок' },
  { id: 2, text: 'Хтось із знайомих нагадає, чому ти цінуєш його дружбу' },
  {
    id: 3,
    text: 'Ти відчуєш, що хтось поруч цінує тебе більше, ніж ти уявляв'
  },
  { id: 4, text: 'Скоро ти отримаєш приємну нагороду за свої зусилля' },
  { id: 5, text: 'Твої плани можуть трохи змінитися, але це буде на краще' },
  { id: 6, text: 'Незабаром один день принесе тобі тепле відчуття гармонії' },
  {
    id: 7,
    text: 'Твоє серце знайде причину битися частіше – і це буде не стрес'
  },
  {
    id: 8,
    text: 'Сьогодні на тебе подивляться, як на головного героя серіалу'
  },
  {
    id: 9,
    text: 'Твоє майбутнє виглядає світлим, так що не забувай свої окуляри!'
  },
  { id: 10, text: 'Твій жарт стане сьогодні легендою серед друзів' },
  {
    id: 11,
    text: 'На тебе чекає важлива розмова, вона відкриє нові можливості'
  },
  {
    id: 12,
    text: 'Найближчими днями ти отримаєш увагу, яка зігріє краще за ковдру'
  },
  {
    id: 13,
    text: 'Сьогодні чудовий день щоб зробити собі маленький подарунок'
  },
  {
    id: 14,
    text: 'Сьогодні ти відчуєш- твоя харизма входить в кімнату ще до тебе!'
  },
  {
    id: 15,
    text: 'Твоя присутність комусь дуже сьогодні потрібна. Цікаво, кому?'
  },
  {
    id: 16,
    text: 'Хтось спробує тебе здивувати. І так, цього разу їм вдасться!'
  },
  {
    id: 17,
    text: 'Невдовзі ти зрозумієш: ти не все контролюєш, і це навіть добре'
  },
  { id: 18, text: 'На тебе чекає спонанна поїздка, що стане приєною історією' },
  {
    id: 19,
    text: 'Ти отримаєш несподіваний комплімент. Це підніме твій настрій!'
  },
  { id: 20, text: "Твоє ім'я сьогодні голосно прозвучало в чиїхось думках" },
  {
    id: 21,
    text: 'Кожен твій крок сьогодні підтверджує- ти рухаєшся куди треба'
  },
  { id: 22, text: 'Не бійся змін, вони можуть привести до чогось чудового' },
  {
    id: 23,
    text: 'День натякає взяти кавову перерву і поспати завтра трішки довше'
  },
  {
    id: 24,
    text: 'Всесвіт шепоче: твоє довгоочікуване бажання вже в дорозі до тебе'
  },
  {
    id: 25,
    text: 'Скоро ти знайдеш своє натхнення там, де навіть його не шукав!'
  },
  {
    id: 26,
    text: 'Час провести діалог з собою- у тиші ти почуєш важливі відповіді'
  },
  {
    id: 27,
    text: 'Час зупинитися і провести час з тими, хто цінує тебе найбільше!'
  },
  {
    id: 28,
    text: 'Тобі судилося сьогодні поїсти щось смачненьке, тому не зволікай!'
  },
  {
    id: 29,
    text: 'Цей день матиме запах чаю, спокою і легкості. Насолоджуйся!'
  },
  { id: 30, text: 'Ймовірність випадкового щастя сьогодні дуже висока' },
  { id: 31, text: 'Сьогодні твоя інуїція- провідник до вдалих рішень.' },
  { id: 32, text: 'Сьогодні твоя усмішка відкриє більше дверей, ніж ключі' },
  { id: 33, text: 'Не бійся ризикувати – пригоди зроблять день незабутнім!' },
  { id: 34, text: 'Не забувай – іноді найкраще рішення це просто бути собою' },
  {
    id: 35,
    text: 'Саме зараз твоя енергія притягне тих людей, які тобі потрібні'
  },
  {
    id: 36,
    text: 'Сьогодні твій день буде таким же світлим, як світанок над містом'
  },
  {
    id: 37,
    text: 'Твій настрій підніме повідомлення, якого ти зовсім не чекав.'
  },
  { id: 38, text: 'Сьогоднішній хаотичний день веде до важливої мети' },
  {
    id: 39,
    text: 'Сьогодні твій внутрішній GPS буде вести тебе потрібним шляхом'
  },
  {
    id: 40,
    text: 'Головний спецефект дня – нова іскра натхнення, лови момент!'
  },
  { id: 41, text: 'Дрібна підказка всередині тебе стане ключем до важливого' },
  { id: 42, text: 'Проблеми які здаються великими, скоро втратять свою силу' },
  {
    id: 43,
    text: 'Зараз сприятливий час для нового проекту, у тебе все вийде!'
  },
  { id: 44, text: 'Удача вже поруч, зроби ще крок і вона тебе знайде!' },
  { id: 45, text: 'Сьогодні твоя енергія буде притягувати компліменти!' },
  {
    id: 46,
    text: 'Зірки радять тобі більше часу проводити на свіжому повітрі.'
  },
  {
    id: 47,
    text: 'Очікуй на перемогу в тих питаннях, які ти давно обмірковуєш'
  },
  { id: 48, text: 'Ти на порозі великих змін. Бажання стануть реальністю' },
  { id: 49, text: 'Сьогодні віра у свої сили призведе до значного досягнення' },
  { id: 50, text: 'Тебе чекає нове захоплення, яке займе твої думки і час.' }
];
